import {Inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {YzSelectContactsComponent} from './yz-select-contacts.component';
import {BASE_CLIENT, BaseClient} from '../../client/base.client';
import {TokenService} from "../../token/token.service";

@Injectable({
  providedIn: 'root'
})

export class YzSelectContactsService {

  constructor(public dialog: MatDialog,
              @Inject(BASE_CLIENT) private client: BaseClient,
              private http: HttpClient,
              private tokenService: TokenService) {

  }


  /**
   * 选择人员
   * @param option
   */
  choosePeople(option: { includeClass?: boolean, includeHisClass?: boolean, count?: number, defaultContacts?: Array<any>, onlyStudent?: boolean, userTypes?: string, onOk?: (value: any) => void }) {
    if (this.tokenService.get().accessToken) {
      const dialogRef = this.dialog.open(YzSelectContactsComponent, {
        panelClass: 'yz-select-contacts-panel',
        closeOnNavigation: true,
        data: {
          includeClass: option.includeClass == undefined ? true : option.includeClass,
          includeHisClass: option.includeHisClass == undefined ? true : option.includeHisClass,
          count: option.count == undefined ? 0 : option.count,
          defaultContacts: option.defaultContacts == undefined ? [] : option.defaultContacts,
          onlyStudent: option.onlyStudent == undefined ? false : option.onlyStudent,
          userTypes: option.userTypes == undefined ? null : option.userTypes
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (option.onOk) {
          option.onOk(result ? result : []);
        }
      });
    } else {
      alert('无法获取Token,请刷新！');
    }
  }


  /**
   * 查询部门树
   * @param includeClass 是否包含班级
   * @param includeHisClass 是否包含历史班级,只在includeClass=true时起作用
   */
  getDeptTree(includeClass: boolean, includeHisClass: boolean): Observable<Array<any>> {
    let url = `${this.client.gateway}/auth/baseDepartMent/tree`;
    if (includeClass) {
      if (includeHisClass) {
        url = url + `?includeClass=true&includeHisClass=true`
      } else {
        url = url + `?includeClass=true&includeHisClass=false`
      }
    } else {
      url = url + `?includeClass=false`
    }
    return this.http.get(url).pipe(
      map((response: any) => {
        return response.data ? response.data : [];
      })
    );
  }


  /**
   * 查询部门树->只选学生（系部+班级）
   * @param gradeId 年级id
   */
  getDeptTreeOnlyStu(gradeId: string, includeClass: boolean, includeHisClass: boolean): Observable<Array<any>> {
    let url;
    if (gradeId) {
      url = `${this.client.gateway}/auth/baseDepartMent/tree?gradeId=${gradeId}&deptTypes=2,class`;

      if (includeClass) {
        if (includeHisClass) {
          url = url + `&includeClass=true&includeHisClass=true`
        } else {
          url = url + `&includeClass=true&includeHisClass=false`
        }
      } else {
        url = url + `&includeClass=false`
      }

    } else {
      url = `${this.client.gateway}/auth/baseDepartMent/tree?deptTypes=2,class`;

      if (includeClass) {
        if (includeHisClass) {
          url = url + `&includeClass=true&includeHisClass=true`
        } else {
          url = url + `&includeClass=true&includeHisClass=false`
        }
      } else {
        url = url + `&includeClass=false`
      }
    }
    return this.http.get(url).pipe(
      map((response: any) => {
        return response.data ? response.data : [];
      })
    );
  }


  /**
   * 查询人员列表
   * @param pageNum 当前页面
   * @param pageSize 每页条数
   * @param realName 姓名
   * @param deptId 部门id
   * @param userTypes 用户类型1,2,3,4逗号拼接：查询普通部门的用户（不包括学生）传“1,4”；查询学生用户传“2,3”；查询所有用户不传
   */
  getBaseUser(pageNum: number, pageSize: number, realName: string, deptId: string, userTypes: string): Observable<Array<any>> {
    return this.http.post(`${this.client.gateway}/auth/baseUser/queryListForPage`, {
      "pageNum": pageNum,
      "pageSize": pageSize,
      "pageParam": {
        "realName": realName,
        "deptId": deptId,
        "userTypes": userTypes
      }
    }).pipe(
      map((response: any) => {
        return response ? response : null;
      })
    );
  }


  /**
   * 查询人员信息
   * @param userIds[] 用户id数组,["aaa","bbb","ccc"]
   */
  getUserByUserIds(userIds: any): Observable<Array<any>> {
    return this.http.post(`${this.client.gateway}/auth/baseUser/users`, {
      userIds: userIds
    }).pipe(
      map((response: any) => {
        return response.data ? response.data : [];
      })
    );
  }

  /**
   * 查询年级
   */
  getGrade(): Observable<Array<any>> {
    return this.http.get(`${this.client.gateway}/auth/gradeYear/queryListForPage`).pipe(
      map((response: any) => {
        return response.data ? response.data : [];
      })
    );
  }

}

